export const CREATE_SCENARIO = 'CREATE_SCENARIO';
export const UPDATE_SCENARIO = 'UPDATE_SCENARIO';
export const REMOVE_SCENARIO = 'REMOVE_SCENARIO';
export const REMOVE_SCENARIO_SUCCESS = 'REMOVE_SCENARIO_SUCCESS';
export const REMOVE_SCENARIO_FAILURE = 'REMOVE_SCENARIO_FAILURE';

export const UPDATE_SCENARIO_LIST_COLUMN_STATE = 'UPDATE_SCENARIO_LIST_COLUMN_STATE';
